"use client";

import { IconFlame } from "@tabler/icons-react";
import { useTranslations } from "next-intl";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

export const LengthDiscountBadge = ({
  maxDiscount,
}: {
  /** When given, the badge names the highest reachable discount instead of the generic copy. */
  maxDiscount?: number;
}) => {
  const t = useTranslations();
  return (
    <Badge
      variant="outline"
      className={cn(
        "rounded-full border-0 bg-brand-red/10 px-3 py-1.5 text-brand-red md:px-2",
      )}
    >
      <p className="flex items-center gap-1 overflow-hidden text-ellipsis whitespace-nowrap font-normal text-xs leading-4.5 md:font-medium">
        <IconFlame className="size-4 min-h-4 min-w-4" stroke={1.5} />
        <span>
          {maxDiscount
            ? t("diets.discountForLengthUpTo", { discount: maxDiscount })
            : t("diets.discountForLengthCta")}
        </span>
      </p>
    </Badge>
  );
};
